
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Loading, LoadingTemplateType, RigheReintegroList } from '@/components';
import { Reintegro } from '@/models';
import { store, StoreActions, StoreMutations } from '@/store';
import dayjs from 'dayjs';
import { saveAs } from 'file-saver';

@Component({
  components: {
    Loading,
    RigheReintegroList
  }
})
export default class ReintegroDettaglio extends Vue {
  private idReintegro!: string;  
  get user() {return store.state.currentUsr;}
  get reintegro(): Reintegro | undefined {
    return store.state.reintegroCorrente;
  }

  get loadTemplateCorrente(): LoadingTemplateType {
    return LoadingTemplateType.ReintegroDettaglio;
  }
  get userIsAdmin() {
    return (
      this.user.roles.find((x: string) => x.toLowerCase() == 'admin') !=
      undefined
    );
  }

  private async downloadCSVReintegro(){
    let data = await store.dispatch(StoreActions.DownloadCSVReintegro, {idReintegro: this.idReintegro });
    if(data){                          
      saveAs(data, `reintegro_${this.idReintegro}.csv`);                    
    }
  }

  @Watch('$route.params.id', { immediate: true })
  onIdChanged(newId: string, oldId: string) {    
    this.idReintegro = newId;
    store.commit(StoreMutations.SetSottotitoloPagina, newId);
    store.dispatch(StoreActions.GetReintegro, newId);    
  }
  
  created(): void {    
    if (this.userIsAdmin) {      
      store.dispatch(StoreActions.GetFornitori);
    } 
  }
  get loading() {
    return store.state.loading;
  }
  
  get csvButtonLoading(){
    return store.state.uiReintegri.csvButtonLoading;
  }
}
